module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <div class=\"modal-content panel-danger\"> <div class=\"modal-header panel-heading\"> <button type=button class=close ng-click=$hide()>&times;</button> <h4 class=modal-title><i class=\"fa fa-exclamation-triangle\"></i> {{'admin.creation_failed_title' | translate}}</h4> </div> <div class=modal-body>{{'admin.creation_failed' | translate}}</div> <div class=modal-footer> <button type=button class=\"btn btn-default\" ng-click=$hide()>Ok</button> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/create/failed.modal.tpl.html
 ** module id = 155
 ** module chunks = 0
 **/